import { Box, ClickAwayListener, TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { IFilterComponentProps } from 'components/Table/TableFilter/types'
import dayjs from 'dayjs'
import { useState } from 'react'
import {
  dateRangeInputStyles,
  inputStyles,
  rangeFilterContainer,
  rangePickersContainer,
} from '../Inputs.style'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

function RangeFilterInput({
  value,
  columnId,
  handleFilterState,
  startAdornment,
  filterType,
}: IFilterComponentProps) {
  const [isOpen, setIsOpen] = useState<boolean>(true)

  const setFrom = (startDate) => {
    handleFilterState(columnId, filterType, [
      startDate?.utc(true) || '',
      value?.[1],
    ])
  }

  const setTo = (endDate) => {
    handleFilterState(columnId, filterType, [
      value?.[0],
      endDate?.utc(true) || '',
    ])
  }

  return (
    <ClickAwayListener
      onClickAway={() => {
        setIsOpen(false)
      }}
    >
      <Box sx={rangeFilterContainer}>
        {isOpen ? (
          <Box sx={rangePickersContainer}>
            <DatePicker
              format="DD/MM/YYYY"
              value={value?.[0] || null}
              onChange={(fromValue) => setFrom(fromValue)}
              slotProps={{
                textField: {
                  variant: 'standard',
                },
              }}
              sx={dateRangeInputStyles}
            />
            <DatePicker
              format="DD/MM/YYYY"
              value={value?.[1] || null}
              onChange={(toValue) => setTo(toValue)}
              minDate={value?.[0] ? dayjs(value?.[0]) : null}
              slotProps={{
                textField: {
                  variant: 'standard',
                },
              }}
              sx={dateRangeInputStyles}
            />
          </Box>
        ) : (
          <TextField
            fullWidth
            variant="standard"
            value={`${value?.[0] ? dayjs(value?.[0]).format('DD/MM/YYYY') : '-'} - ${
              value?.[1] ? dayjs(value?.[0]).format('DD/MM/YYYY') : '-'
            }`}
            InputProps={{
              startAdornment,
              onFocus: (e) => {
                setIsOpen(true)
              },
            }}
            sx={inputStyles}
          />
        )}
      </Box>
    </ClickAwayListener>
  )
}

export default RangeFilterInput
